module.exports = __webpack_public_path__ + "863055ced298bc1c828029541c4152bd.MP3";